export default __webpack_public_path__ + "static/media/client3.eb27f4f6.jpeg";